// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8842cf4e","453":"46dc3e92","455":"fbfbeb6b","977":"27fd85c8"}[chunkId] + ".chunk.js";
};